import styled from "styled-components";

const SidePanelStyled = styled.div` 
  text-align: center;

.backDrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2147483640;
}

.modal {
  position: fixed;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  padding: 12px 24px;
  height: 100%;
  background: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  z-index: 2147483642;
  transform: translateX(100%);
  transition: all 0.3s ease-in-out;
  overflow: auto;
 
}

@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
   .modal {
      padding: 40px 56px 56px 56px;
      width: 540px;
   }
   .modal-content {
    padding: 20px;
}
  }



.modal.open {
  opacity: 1;
  transform: translateX(0);
}

.closeButton {
    display: flex;
    justify-content: flex-end;
    align-items: center ;
    cursor: pointer;
    font-size: 1.6rem;
    color: #008755;
    font-weight: 700;
    gap: 5px;
 }

 
`;




export { SidePanelStyled};